module.exports = __webpack_public_path__ + "img/portifolio_eletromobilidade.12c2d97c.jpg";